// extracted by mini-css-extract-plugin
export var actionButton = "_81-1";
export var actionButtons = "_81-2";
export var actions = "_81-0";
export var aiUnread = "_81-10";
export var alignCenter = "_81-h";
export var backWrapper = "_81-3";
export var cellContainer = "_81-4";
export var checkboxContainer = "_81-5";
export var contentContainer = "_81-6";
export var contentHeader = "_81-8";
export var conversationsTableWrapper = "_81-s";
export var draftReplyBadgeContainer = "_81-m";
export var dropdownItem = "_81-b";
export var dropdownItemsContainer = "_81-a";
export var dropdownTitle = "_81-c";
export var errorIcon = "_81-7";
export var filter = "_81-d";
export var gray = "_81-i";
export var headerActionButtons = "_81-e";
export var headerCheckboxContainer = "_81-f";
export var icon = "_81-j";
export var menuContainer = "_81-k";
export var noMoreTicketsIcon = "_81-12";
export var noMoreTicketsSubText = "_81-13";
export var oneLine = "_81-l";
export var optionsButton = "_81-n";
export var plus = "_81-o";
export var portalButtonsWrapper = "_81-g";
export var red = "_81-p";
export var scrolledTop = "_81-9";
export var search = "_81-q";
export var selectedConversationsCount = "_81-r";
export var spinner = "_81-t";
export var strong = "_81-u";
export var summaryCell = "_81-v";
export var tableContainer = "_81-11";
export var tagContainer = "_81-w";
export var threeDots = "_81-x";
export var twoLines = "_81-y";
export var unread = "_81-z";